import { Item } from "@/client/components/shad/item";
import { Separator } from "@/client/components/shad/separator";
import {
  IconChevronRight,
  IconDrone,
  IconVideoPlus,
} from "@tabler/icons-react";

export const PdarTargets = () => {
  return (
    <>
      <div className="h-48 flex flex-col gap-2 items-center justify-center border rounded-md bg-zinc-800">
        <IconDrone size={48} className="opacity-20" />
        <span className="text-muted-foreground">No Targets</span>
      </div>
    </>

    //
    // <div className="grid gap-3">
    //   <div className="bg-zinc-800 text-xs hover:bg-sky-400/50 p-3 border border-sky-400">
    //     <p>Drone</p>
    //   </div>
    //   <div className="bg-zinc-800 text-xs hover:bg-sky-400/50 p-3">
    //     <strong>Pilot</strong>
    //   </div>
    //   <div className="bg-zinc-800 text-xs hover:bg-sky-400/50 p-3">
    //     <strong>All</strong>
    //   </div>
    // </div>
  );
};
